import React from "react";

/**
 * Kelompok label for a request row.
 *
 * `name` is null whenever the request never got routed — the gudang it targets
 * has no owner, or whoever submitted it isn't in a kelompok. That is worth
 * showing loudly rather than hiding behind a dash: with pembatasan per-kelompok
 * switched on, an unrouted request is one nobody but a superadmin can ACC, and
 * the fix (assign the gudang an owner) isn't obvious from the request itself.
 */
export function TeamTag({ name, title, color }) {
  if (!name) {
    return (
      <span className="team-tag team-tag-none" title={title || "Belum diarahkan ke kelompok mana pun"}>
        tanpa kelompok
      </span>
    );
  }
  return (
    <span className="team-tag" title={title}>
      {/* Optional — leaving `color` unset keeps every existing call site
          (routing summaries, "tanpa pemilik") exactly as neutral as before. */}
      {color && (
        <span
          aria-hidden="true"
          style={{
            width: 7, height: 7, borderRadius: "9999px", flexShrink: 0,
            background: color,
          }}
        />
      )}
      {name}
    </span>
  );
}

/** Requester → approver, the whole routing of one request in one cell. */
export function TeamRoute({ requester, approver }) {
  return (
    <span className="inline-flex items-center gap-1 flex-wrap">
      <TeamTag name={requester} title="Kelompok pengaju" />
      <span style={{ color: "var(--text-secondary)", fontSize: "0.7rem" }}>→</span>
      <TeamTag name={approver} title="Kelompok yang meng-ACC" />
    </span>
  );
}

export default TeamTag;
